module.exports = __webpack_public_path__ + "images/emoji/clock1130.b9c9340720b8e84d1129.png";